export default {
  "content": "<path fill=\"#ff00cb\" d=\"M19 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3h3v2h8v-2h3c1.66 0 3-1.34 3-3V7c0-1.66-1.34-3-3-3zm1 11c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v8z\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};